import { render, staticRenderFns } from "./CommunityElderByInterval.vue?vue&type=template&id=47981488&scoped=true&"
import script from "./CommunityElderByInterval.vue?vue&type=script&lang=js&"
export * from "./CommunityElderByInterval.vue?vue&type=script&lang=js&"
import style0 from "./CommunityElderByInterval.vue?vue&type=style&index=0&id=47981488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47981488",
  null
  
)

export default component.exports